/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "@lhd/components/Loading";
import { ROUTES } from "@lhd/constants";
import { setCompanyId } from "@lhd/utility";
import {
  RETURN_AFTER_LOGIN_STORAGE_KEY,
  DIAGRAM_ROUTE_PERMISSION,
  PATH_YEAR_PLACEHOLDER,
} from "@lhd/features/CorrelationDiagram/constants";
import useCompanies, { Props, ReceivedProps } from "./hook";

const REDIRECT_AFTER_LOGIN_DELAY = 500;

const CompanyLayout: FC<Props> = ({ permission, auth }) => {
  const navigate = useNavigate();
  const hasHandledIntendedRef = useRef(false);

  useEffect(() => {
    localStorage.removeItem("company_name");
    const intendedRouteKey = sessionStorage.getItem(
      RETURN_AFTER_LOGIN_STORAGE_KEY,
    );

    if (!intendedRouteKey) {
      navigate(ROUTES.CORRELATION_DIAGRAM);
      return;
    }

    const handleIntendedRoute = () => {
      if (hasHandledIntendedRef.current) return;
      if (!auth) {
        return;
      }

      const config = DIAGRAM_ROUTE_PERMISSION[intendedRouteKey];

      if (!config) {
        sessionStorage.removeItem(RETURN_AFTER_LOGIN_STORAGE_KEY);
        hasHandledIntendedRef.current = true;
        navigate(`/${ROUTES.CORRELATION_DIAGRAM}`);
        return;
      }

      let path = config.path.replace(
        new RegExp(PATH_YEAR_PLACEHOLDER.replace(/[{}]/g, "\\$&"), "g"),
        String(new Date().getFullYear()),
      );

      if (path.includes("{companyId}")) {
        if (!auth?.companies?.length) {
          return;
        }
        const company =
          auth?.companies?.find((c: any) => c.is_work_default) ||
          auth?.companies?.[0];
        const companyId = company?.id;
        if (companyId != null) {
          path = path.replace(/\{companyId\}/g, String(companyId));
          setCompanyId(String(companyId));
        } else {
          path = `/${ROUTES.COMPANIES}`;
        }
      }

      hasHandledIntendedRef.current = true;
      sessionStorage.removeItem(RETURN_AFTER_LOGIN_STORAGE_KEY);
      navigate(path, { state: { fallback: `/${ROUTES.CORRELATION_DIAGRAM}` } });
    };

    const timer = setTimeout(
      handleIntendedRoute,
      auth ? 0 : REDIRECT_AFTER_LOGIN_DELAY,
    );
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth, auth?.companies]);

  return <Loading />;
};

const Company: FC<ReceivedProps> = (props) => (
  <CompanyLayout {...useCompanies(props)} />
);

export default Company;
